import { SALES_ORDER_REVERT_BLOCKED_BY_PRODUCTION_MESSAGE } from "@integrator-src/sales-order/sales-order-cancel-eligibility";

export function resolveSalesOrderStatusChangeBlockedHint(input: {
  unsavedChangesHint?: string | null;
}): string | null {
  const hint = input.unsavedChangesHint?.trim() ?? "";
  if (hint === "") {
    return null;
  }
  return `Save your changes before changing order status.\n\n${hint}`;
}

export function resolveSalesOrderRevertToPendingBlockedHint(input: {
  unsavedChangesHint?: string | null;
  hasProductionBatchItems?: boolean;
}): string | null {
  if (input.hasProductionBatchItems === true) {
    return SALES_ORDER_REVERT_BLOCKED_BY_PRODUCTION_MESSAGE;
  }
  return resolveSalesOrderStatusChangeBlockedHint({ unsavedChangesHint: input.unsavedChangesHint });
}
